export const teamMember = kendo.data.Model.define({
  id: 'EmpId',
  fields: {
    EmpId: {
      type: 'number',
      editable: false
    },
    FirstName: {
      type: 'string'
    },
    LastName: {
      type: 'string'
    },
    FullName: {
      type: 'string'
    },
    Title: {
      type: 'string'
    },
    Email: {
      type: 'string'
    },
    DisplayName: {
      type: 'string'
    }
  }
});

export const approval = kendo.data.Model.define({
  id: 'Role',
  fields: {
    Id: {
      type: 'number',
      editable: false
    },
    Order: {
      type: 'number',
      editable: false
    },
    Role: {
      type: 'string',
      editable: false
    },
    IsApproved: {
      type: 'boolean',
      editable: false
    },
    ApprovedBy: {
      type: 'string',
      editable: false
    },
    ApprovedOn: {
      type: 'date',
      editable: false
    }
  }
});